import { render, staticRenderFns } from "./client-group-data-grid.vue?vue&type=template&id=87055b50&"
import script from "./client-group-data-grid.vue?vue&type=script&lang=ts&"
export * from "./client-group-data-grid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports